import { useState } from "react";

import { CreateLocationModal, DealersDashboardFilters, DealersDashboardTable } from "modules/DealersDashboard/components";
import "modules/DealersDashboard/DealersDashboard.scss";

import type { DealerID } from "models";

export const DealersDashboard = () => {
  const [dealerIdForNewLocation, setDealerIdForNewLocation] = useState<DealerID | null>(null);

  return (
    <div className="DealersDashboard">
      <DealersDashboardFilters />
      <DealersDashboardTable onAddLocation={setDealerIdForNewLocation} />
      {!!dealerIdForNewLocation && <CreateLocationModal dealerId={dealerIdForNewLocation} onClose={() => setDealerIdForNewLocation(null)} />}
    </div>
  );
};
